module.exports = __webpack_public_path__ + "img/system-4.569252c.png";